import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ListOptionVariant } from '@app/models/asset';
import * as _ from 'lodash';

@Component({
    selector: 'pr-search-input',
    templateUrl: './pr-search-input.component.html',
    styleUrls: ['./pr-search-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PrSearchInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class PrSearchInputComponent implements ControlValueAccessor {
  _list;
  set list(val) {
    this._list = val;
    this.dataListSearched = this.formatedOptions();
  }
  @Input() get list() {
    return this._list;
  }

  _dataListSearched;
  set dataListSearched(val) {
    this._dataListSearched = val;
    this.dataListSearchedChange.emit(val);
  }
  @Input() get dataListSearched() {
    return this._dataListSearched;
  }
  @Output() dataListSearchedChange = new EventEmitter<any>();
  @Input() searchProperty = 'name';
  @Input() placeholder = '';
  @Input() variant: ListOptionVariant = 'DEFAULT';

  _searchValue = '';
  @Input() get searchValue() {
    return this._searchValue;
  }
  set searchValue(val) {
    this._searchValue = val;
    this.propagateChanges(this._searchValue);
    this.searchValueChange.emit(this._searchValue);
    this.dataListSearched = this.formatedOptions();
  }
  @Output() searchValueChange = new EventEmitter<string>();

  writeValue(value: any): void {
    if (value !== undefined) {
      this.searchValue = value;
    }
  }

  propagateChanges = (_: any) => {};

  registerOnChange(fn: any): void {
    this.propagateChanges = fn;
  }

  registerOnTouched(fn: any): void {}

  formatedOptions() {
    return this.searchValue
      ? _.filter(this.list, item =>
          item[this.searchProperty]
            .toLowerCase()
            .includes(this.searchValue.toLowerCase()),
        )
      : this.list;
  }
}
